<div class="circle wrapper" ngbTooltip="{{statusLabel}}"
     [class.default]="statusId == CplUserStatus.NONE || statusId === CplUserStatus.DEFAULT"
     [class.verified]="statusId === CplUserStatus.VERIFIED"
     [class.expiring]="statusId === CplUserStatus.EXPIRING"
     [class.pending]="statusId === CplUserStatus.PENDING"
     [class.expired]="statusId === CplUserStatus.EXPIRED"
     [class.declined]="statusId === CplUserStatus.DECLINED"
     [class.forgiven]="statusId === CplUserStatus.FORGIVEN"
     [class.partialComplete]="statusId === CplUserStatus.COMPLETE_NOTALL_APPROVED">
    <i [ngClass]="getIcon()"></i>
</div>